(function($) {
  
   var   body = $('body'),
        doc = $(document),
        html = $('html'),
        win = $(window);
   
   
    if ($(".collection-sidebar")) {
        //work only in collection page
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!forte.isSidebarAjaxClick) {
                forte.sidebarParams();
                var newurl = forte.sidebarCreateUrl();
                forte.sidebarGetContent(newurl);
                forte.reActivateSidebar();
            }
            forte.isSidebarAjaxClick = false;
        });
    }

    if (window.use_color_swatch) {
        $('.swatch :radio').change(function() {
            var optionIndex = $(this).closest('.swatch').attr('data-option-index');
            var optionValue = $(this).val();
            $(this)
                .closest('form')
                .find('.single-option-selector')
                .eq(optionIndex)
                .val(optionValue)
                .trigger('change');
        });

        // (c) Copyright 2014 Caroline Schnapp. All Rights Reserved. Contact: mllegeorgesand@gmail.com
        // See http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options

        Shopify.optionsMap = {};

        Shopify.updateOptionsInSelector = function(selectorIndex) {

            switch (selectorIndex) {
                case 0:
                    var key = 'root';
                    var selector = $('.single-option-selector:eq(0)');
                    break;
                case 1:
                    var key = $('.single-option-selector:eq(0)').val();
                    var selector = $('.single-option-selector:eq(1)');
                    break;
                case 2:
                    var key = $('.single-option-selector:eq(0)').val();
                    key += ' / ' + $('.single-option-selector:eq(1)').val();
                    var selector = $('.single-option-selector:eq(2)');
            }

            var initialValue = selector.val();
            selector.empty();
            var availableOptions = Shopify.optionsMap[key];
            if (availableOptions && availableOptions.length) {
              for (var i = 0; i < availableOptions.length; i++) {
                  var option = availableOptions[i];
                  var newOption = $('<option></option>').val(option).html(option);
                  selector.append(newOption);
              }
              $('.swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
                  if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
                      $(this).removeClass('soldout').show().find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
                  } else {
                      $(this).addClass('soldout').hide().find(':radio').removeAttr('checked').attr('disabled', 'disabled');
                  }
              });
              if ($.inArray(initialValue, availableOptions) !== -1) {
                  selector.val(initialValue);
              }
              selector.trigger('change');
            }
        };

        Shopify.linkOptionSelectors = function(product) {
            // Building our mapping object.
            for (var i = 0; i < product.variants.length; i++) {
                var variant = product.variants[i];
                if (variant.available) {
                    // Gathering values for the 1st drop-down.
                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                    Shopify.optionsMap['root'].push(variant.option1);
                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                    // Gathering values for the 2nd drop-down.
                    if (product.options.length > 1) {
                        var key = variant.option1;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option2);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                    // Gathering values for the 3rd drop-down.
                    if (product.options.length === 3) {
                        var key = variant.option1 + ' / ' + variant.option2;
                        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                        Shopify.optionsMap[key].push(variant.option3);
                        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                    }
                }
            }
            // Update options right away.
            Shopify.updateOptionsInSelector(0);
            if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
            if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
            // When there is an update in the first dropdown.
            $(".single-option-selector:eq(0)").change(function() {
                Shopify.updateOptionsInSelector(1);
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });
            // When there is an update in the second dropdown.
            $(".single-option-selector:eq(1)").change(function() {
                if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
                return true;
            });

        };
    }

    $(document).ready(function() {
        forte.init();
    });

    $(window).resize(function() {
      	forte.initHeader();
        forte.initDropdownAccount();
        //forte.initMobileSidebar();
        forte.initResizeImage();
    });

    $(window).scroll(function() {
        if ($(this).scrollTop() > 200) {
            $('#back-top').fadeIn();
        } else {
            $('#back-top').fadeOut();
        }
    });

    $(document).on('click touchstart', function(e) {
        var quickview = $(".quick-view");
        var dropdowncart = $("#dropdown-cart");
 
        var cartButton = $("#cartToggle");
        var newsletter = $("#email-modal .modal-window");

        //close quickview and dropdowncart when clicking outside
        if (!newsletter.is(e.target) && newsletter.has(e.target).length === 0 && !quickview.is(e.target) && quickview.has(e.target).length === 0 && !dropdowncart.is(e.target) && dropdowncart.has(e.target).length === 0 && !cartButton.is(e.target) && cartButton.has(e.target).length === 0) {
            forte.closeQuickViewPopup();
            forte.closeDropdownCart();
            forte.closeEmailModalWindow();
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            forte.closeQuickViewPopup();
            forte.closeDropdownCart();
            clearTimeout(forte.forteTimeout);
            if ($('.modal').is(':visible')) {
                $('.modal').fadeOut(500);
            }
        }
    });

    var forte = {
        forteTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {
            this.initColorSwatchGrid();
            this.initResizeImage();
          	this.initHeader();
          	this.initDropdownAccount();
            this.initSidebar();
            this.initMobileSidebar();
            this.initScrollTop();
            this.initQuickView();
            this.initCloudzoom();
            this.initProductMoreview();
            this.initAddToCart();
            this.initModal();
            this.initProductAddToCart();
          	 this.clickedActiveProductTabs();
            this.initDropDownCart();
            this.initToggleCollectionPanel();
            this.initWishlist();
            this.initProductWishlist();
          this.initSlideshow();
            this.initRemoveWishlist();
            this.initInfiniteScrolling();
          	this.initInfiniteScrollingss();
        },
      
//       -----------------------------custom-------------------------
      
      
           initSlideshow: function () {
            var slickSlideshow = $('[data-init-slideshow]');

            if (slickSlideshow.length) {
                slickSlideshow.each(function () {
                    var self = $(this),
                        auto_playvideo = self.data('auto-video');

                    if(auto_playvideo) {
                        // POST commands to YouTube or Vimeo API
                        function postMessageToPlayer(player, command) {
                            if (player == null || command == null) return;
                            player.contentWindow.postMessage(JSON.stringify(command), "*");
                        }

                        // When the slide is changing
                        function playPauseVideo(slick, control) {
                            var currentSlide, player, video;

                            currentSlide = slick.find('.slick-current');
                            player = currentSlide.find("iframe").get(0);

                            if (currentSlide.hasClass('slide-youtube')) {
                                switch (control) {
                                    case "play":
                                        postMessageToPlayer(player, {
                                            "event": "command",
                                            "func": "mute"
                                        });
                                        postMessageToPlayer(player, {
                                            "event": "command",
                                            "func": "playVideo"
                                        });
                                        break;

                                    case "pause":
                                        postMessageToPlayer(player, {
                                            "event": "command",
                                            "func": "pauseVideo"
                                        });
                                        break;
                                }

                            } else if (currentSlide.hasClass('slide-video')) {
                                video = currentSlide.children("video").get(0);

                                if (video != null) {
                                    if (control === "play"){
                                        video.play();
                                    } else {
                                        video.pause();
                                    }
                                }
                            };
                        };

                        self.on('init', function(slick) {
                            slick = $(slick.currentTarget);

                            setTimeout(function(){
                                playPauseVideo(slick,"play");
                            }, 1000);
                        });

                        self.on("beforeChange", function(event, slick) {
                            slick = $(slick.$slider);
                            playPauseVideo(slick,"pause");
                        });

                        self.on("afterChange", function(event, slick) {
                            slick = $(slick.$slider);
                            playPauseVideo(slick,"play");
                        });
                    };

                    if (self.not('.slick-initialized')) {
                        self.slick({
                            dots: self.data('dots'),
                            slidesToScroll: 1,
                            verticalSwiping: false,
                            fade: self.data('fade'),
                            cssEase: "ease",
                            adaptiveHeight: true,
                            autoplay: self.data('autoplay'),
                            autoplaySpeed: self.data('autoplay-speed'),
                            nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg></button>',
                            prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg></button>',
                            responsive: [{
                                breakpoint: 1280,
                                settings: {
                                    arrows: false,
                                    dots: self.data('dots'),
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    dots: true
                                }
                            }
                            ]
                        });
                    };
                });
            };
        },

      
      clickedActiveProductTabs: function () {
            var productTabsSection = $('[data-home-product-tabs]');

            productTabsSection.each(function () {
                var self = $(this),
                    listTabs = self.find('.list-product-tabs'),
                    tabLink = listTabs.find('[data-product-tabTop]'),
                    tabContent = self.find('[data-product-TabContent]');

                var linkActive = self.find('.list-product-tabs .tab-links.active'),
                    activeTab = self.find('.product-tabs-content .tab-content.active');

                forte.doAjaxProductTabs(linkActive.data('href'), activeTab.find('.loading'), activeTab.find('.products-grid'));

                tabLink.off('click').on('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    if($(this).hasClass('active')) {
                        return;
                    }

                    if (!$(this).hasClass('active')) {
                        var curTab = $(this),
                            curTabContent = $(curTab.data('target'));

                        tabLink.removeClass('active');
                        tabContent.removeClass('active');

                        if (!curTabContent.find('.products-grid').hasClass('slick-initialized')) {
                            forte.doAjaxProductTabs(curTab.data('href'), curTabContent.find('.loading'), curTabContent.find('.products-grid'));
                        }

                        curTab.addClass('active');
                        curTabContent.addClass('active');
                    };
                });
            });
        },

        doAjaxProductTabs: function (handle, loadingElm, curTabContent) {
            // if (ella.isAjaxLoading) return;

            $.ajax({
                type: "get",
                url: handle,

                beforeSend: function () {
                    loadingElm.text('Loading ... please wait ...');
                },

                success: function (data) {
                    loadingElm.hide();

                    if (handle == '/collections/?view=json') {
                        loadingElm.text('Please link to collections').show();
                    } else {
                        curTabContent.html($(data).find('.grid-items').html());

                        if (!curTabContent.hasClass('slick-initialized')) {
                            forte.initProductTabsSlider(curTabContent.parent());
                        };

                        if (forte.checkNeedToConvertCurrency()) {
                            Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
                        };

                        forte.translateBlock('[data-home-product-tabs]');
                        forte.initColorSwatchGrid();
//                         forte.initWishListIcons();

                        forte.forteTimeout = setTimeout(function () {
                            if ($('.shopify-product-reviews-badge').length && $('.spr-badge').length) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            };
                        }, 1000);
                    };
                },

                error: function (xhr, text) {
                    loadingElm.text('Sorry, there are no products in this collection').show();
                }
            });
        },

        initProductTabsSlider: function (slt) {
            slt.each(function () {
                var self = $(this),
                    productGrid = self.find('.products-grid'),
                    gridItemWidth = productGrid.data('row');

                if (productGrid.not('.slick-initialized') && productGrid.find('.grid-item').length) {
                    productGrid.slick({
                        slidesToShow: productGrid.data('row'),
                        slidesToScroll: productGrid.data('row'),
                        dots: false,
                        infinite: false,
                        speed: 1000,
                        nextArrow: '<button type="button" class="slick-next"><i class="fa fa-angle-right"></i></button>',
                        prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-angle-left"></i></button>',
                        responsive: [
                            {
                                breakpoint: 1200,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                    get slidesToShow() {
                                        if(self.hasClass('sections-has-banner')) {
                                            return this.slidesToShow = 2;
                                        }else {
                                            if(gridItemWidth >= 4) {
                                                return this.slidesToShow = 4;
                                            }else if(gridItemWidth = 3) {
                                                return this.slidesToShow = 3
                                            }else {
                                                return this.slidesToShow = 2
                                            }
                                        }
                                    },
                                    get slidesToScroll() {
                                        if (self.hasClass('sections-has-banner')) {
                                            return this.slidesToScroll = 2;
                                        }else {
                                            if(gridItemWidth >= 4) {
                                                return this.slidesToScroll = 4;
                                            }else if(gridItemWidth = 3) {
                                                return this.slidesToScroll = 3
                                            }else {
                                                return this.slidesToScroll = 2
                                            }
                                        };
                                    }
                                }
                            },
                            {
                                breakpoint: 992,
                                settings: {
                                    dots: true,
                                    arrows: false,
                                    get slidesToShow() {
                                        if(self.hasClass('sections-has-banner')) {
                                            return this.slidesToShow = 2;
                                        }else {
                                            if (gridItemWidth >= 3) {
                                                return this.slidesToShow = 3;
                                            } else {
                                                this.slidesToShow = 2
                                            }
                                        }
                                    },
                                    get slidesToScroll() {
                                        if (self.hasClass('sections-has-banner')) {
                                            return this.slidesToScroll = 2;
                                        }else {
                                            if(gridItemWidth >= 3) {
                                                return this.slidesToScroll = 3;
                                            }else {
                                                return this.slidesToScroll = 2
                                            }
                                        };
                                    }
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    slidesToShow: 2,
                                    slidesToScroll: 2,
                                    arrows: false,
                                    dots: true
                                }
                            }
                        ]
                    });
                }
            });
        },
      
//       -----------------------------------------------------------
      
      
      
      
        updatePricingCart: function(productId) {
          
            //try pattern one before pattern 2
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = $('.cart-list #' + productId + ' .price').text().match(regex);

            if (!unitPriceTextMatch) {
                regex = /([0-9]+[.|,][0-9]+)/g;
                unitPriceTextMatch = $('.cart-list #' + productId + ' .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
                var unitPriceText = unitPriceTextMatch[0];
                var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                var quantity = parseInt($('#updates_' + productId + '').val());
                var totalPrice = unitPrice * quantity;

                var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
                if (!totalPriceText.match(regex)) {
                   regex = /([0-9]+[.|,][0-9]+)/g;
                } 
                totalPriceText = totalPriceText.match(regex)[0];

                var regInput = new RegExp(unitPriceText, "g");
                var totalPriceHtml = $('.cart-list #' + productId + ' .price').html().replace(regInput, totalPriceText);

                $('.cart-list #' + productId + ' .total-price span').html(totalPriceHtml);
            }
        },
        initScrollbar: function () {
          $(".sidebar-custom ul").niceScroll({
            cursoropacitymin: 1,
            cursorborder:"",
            cursorwidth: "7px",
            cursorcolor:"#5e5e5e",
            cursorborderradius:0,
            background: "#ebebeb"
          });
        },
        sidebarMapTagEvents: function() {
          	$('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(e) {
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !$(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = $(this).parents('.sidebar-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = $(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                forte.sidebarAjaxClick();
                e.preventDefault();
            });
        },
        sidebarMapCategories: function() {
            $(".sidebar-links a").click(function(e) {
                if (!$(this).hasClass('active')) {
                    delete Shopify.queryParams.q;
                    forte.sidebarAjaxClick($(this).attr('href'));

                    //activate selected category
                    $(".sidebar-links a.active").removeClass("active");
                    $(this).addClass("active");
                  
                  	var par = $(this).parent();
                  	if (par.hasClass("dropdown") && !par.hasClass("click")) {
                    	$(".dropdown.click").removeClass("click");
						par.addClass("click");                  	  
                  	}
                }
                e.preventDefault();
            });
          
          	$(".sidebar-links li .caret").click(function(n)
            {
              	console.log("click there");
                var t = $(this).parent();
                if (t.hasClass("click"))
                {
                    t.removeClass("click");
                }
                else
                {
                    t.addClass("click");
                }              
                n.preventDefault();
            });
        },
        sidebarMapView: function() {
            $(".view-mode a").click(function(e) {
                if (!$(this).hasClass("active")) {
                    var paging = $(".filter-show > button span.number").text();
                    if ($(this).hasClass("list")) {
                        Shopify.queryParams.view = "list" + paging;
                    } else {
                        Shopify.queryParams.view = paging;
                    }

                    forte.sidebarAjaxClick();
                    $(".view-mode a.active").removeClass("active");
                    $(this).addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapShow: function() {
            $(".filter-show a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    var thisPaging = $(this).attr('href');

                    var view = $(".view-mode a.active").attr("href");
                    if (view == "list") {
                        Shopify.queryParams.view = "list" + thisPaging;
                    } else {
                        Shopify.queryParams.view = thisPaging;
                    }

                    forte.sidebarAjaxClick();
                    $(".filter-show > button span.number").text(thisPaging);
                    $(".filter-show li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarInitToggle: function() {
            if ($(".sidebar-tag").length > 0) {
                $(".sidebar-tag .widget-title span").click(function() {
                    var $title = $(this).parents('.widget-title');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $title.addClass('click');
                    }

                    $(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
            }
            if ($(".sidebar-links").length > 0) {
                $('.sidebar-links ul.cat-dropdown a').parents(".dropdown").removeClass("click");  
              	$('.sidebar-links a.active').parents(".dropdown").addClass("click").find("ul.cat-dropdown").show();
            }
        },
        sidebarMapSorting: function(e) {
            $(".filter-sortby a").click(function(e) {
                if (!$(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = $(this).attr("href");
                    forte.sidebarAjaxClick();
                    var sortbyText = $(this).text();
                    $(".filter-sortby > button span").text(sortbyText);
                    $(".filter-sortby li.active").removeClass("active");
                    $(this).parent().addClass("active");
                }
                e.preventDefault();
            });
        },
        sidebarMapPaging: function() {
            $(".pagination-page a").click(function(e) {
                var page = $(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = forte.sidebarCreateUrl();
                        forte.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        forte.sidebarGetContent(newurl);
                        //go to top
                        $('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                e.preventDefault();
            });
        },
        sidebarMapClearAll: function() {
            //clear all selection
            $('.refined-widgets a.clear-all').click(function(e) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                forte.sidebarAjaxClick();
                e.preventDefault();
            });
        },
        sidebarMapClear: function() {
            $(".sidebar-tag").each(function() {
                var sidebarTag = $(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    //has active tag
                    sidebarTag.find(".clear").show().click(function(e) {
                      console.log("im clicked");
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = $(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
						forte.sidebarAjaxClick();
                        e.preventDefault();
                    });
                }
            });
        },
        sidebarMapEvents: function() {
            forte.sidebarMapTagEvents();
            forte.sidebarMapCategories();
            forte.sidebarMapView();
            forte.sidebarMapShow();
            forte.sidebarMapSorting();
        },
        reActivateSidebar: function() {
            $(".sidebar-custom .active, .sidebar-links .active").removeClass("active");
            $(".sidebar-tag input:checked").attr("checked", false);

            //category
            var cat = location.pathname.match(/\/collections\/(.*)(\?)?/);
            if (cat && cat[1]) {
                $(".sidebar-links a[href='" + cat[0] + "']").addClass("active");
            }

            //view mode and show filter
            if (Shopify.queryParams.view) {
                $(".view-mode .active").removeClass("active");
                var view = Shopify.queryParams.view;
                if (view.indexOf("list") >= 0) {
                    $(".view-mode .list").addClass("active");
                    //paging
                    view = view.replace("list", "");
                } else {
                    $(".view-mode .grid").addClass("active");
                }
                $(".filter-show > button span.number").text(view);
                $(".filter-show li.active").removeClass("active");
                $(".filter-show a[href='" + view + "']").parent().addClass("active");
            }
            forte.initSortby();
        },
        initSortby: function() {
            //sort by filter
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                var sortbyText = $(".filter-sortby a[href='" + sortby + "']").text();
                $(".filter-sortby > button span").text(sortbyText);
                $(".filter-sortby li.active").removeClass("active");
                $(".filter-sortby a[href='" + sortby + "']").parent().addClass("active");
            }
        },
        sidebarMapData: function(data) {
            var currentList = $(".col-main .products-grid");
            if (currentList.length == 0) {
                currentList = $(".col-main .product-list");
            }
            var productList = $(data).find(".col-main .products-grid");
            if (productList.length == 0) {
                productList = $(data).find(".col-main .product-list");
            }
            if (productList.length > 0 && productList.hasClass("products-grid")) {
                if (window.product_image_resize) {
                    productList.find('img').fakecrop({
                        fill: window.images_size.is_crop,
                        widthSelector: ".products-grid .grid-item .product-image",
                        ratioWrapper: window.images_size
                    });
                }
            }
            currentList.replaceWith(productList);
            //convert currency
            if (forte.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.col-main span.money', 'money_format');
            }

            //replace paging
            if ($(".padding").length > 0) {
                $(".padding").replaceWith($(data).find(".padding"));
            } else {
                $(".block-row.col-main").append($(data).find(".padding"));
            }

            //replace title & description
            var currentHeader = $(".page-header");
            var dataHeader = $(data).find(".page-header");
            if (currentHeader.find("h2").text() != dataHeader.find("h2").text()) {
                currentHeader.find("h2").replaceWith(dataHeader.find("h2"));
              
                var currentDes = $(".collection-des");
                var dataDes = $(data).find(".collection-des");
              
                if (currentDes.find(".rte").length) {
                    if (dataDes.find(".rte").length) {
                        currentDes.html(dataDes.find(".rte"));
                    } else {
                        currentDes.find(".rte").hide();
                    }
                } else {
                    currentDes.html(dataDes.find(".rte"));
                }
              
                var currentImg = $(".collection-img");
                var dataImg = $(data).find(".collection-img");
                if (currentImg.find("p").length) {
                    if (dataImg.find("p").length) {
                        currentImg.html(dataImg.find("p"));
                    } else {
                        currentImg.find("p").hide();
                    }
                } else {
                    currentImg.html(dataImg.find("p"));
                }
            }

            //replace refined
            $(".refined-widgets").replaceWith($(data).find(".refined-widgets"));
            
            //replace tags
            $(".sidebar-block").replaceWith($(data).find(".sidebar-block"));
          
            forte.initColorSwatchGrid();
          
            //product review
            if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
        },
        sidebarCreateUrl: function(baseLink) {
            var newQuery = $.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = forte.sidebarCreateUrl(baseLink);
            forte.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            forte.sidebarGetContent(newurl);
        },
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    forte.showLoading();
                },
                success: function(data) {
                    forte.sidebarMapData(data);
                    forte.sidebarMapPaging();
                    forte.translateBlock(".main-content");
                    forte.sidebarMapTagEvents();
                    forte.sidebarInitToggle();
                    forte.sidebarMapClear();
                    forte.sidebarMapClearAll();
                    forte.hideLoading();

                    forte.initQuickView();
                    forte.initAddToCart();
                    forte.initWishlist();
                    forte.initInfiniteScrolling();
                    //forte.initScrollbar();
                },
                error: function(xhr, text) {
                    forte.hideLoading();
                    $('.loading-modal').hide();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    forte.showModal('.ajax-error-modal');
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
        initMobileSidebar: function() {
            //if ($(".header-mobile").is(":visible")) {
            $('footer').append("<a class='option-sidebar left' id='displayTextLeft' href='javascript:void(0)'><span>" + window.side_bar.show_sidebar + "</span></a>");
            $('#displayTextLeft').click(
                function(event) {
                    event.preventDefault();
                    if ($('.sidebar').is(":hidden")) {
                        //jQuery('.col-main').fadeOut(800);
                        $('.sidebar').fadeIn(800);
                        $('body,html').animate({
                            scrollTop: 400
                        }, 600);
                        $('#displayTextLeft').toggleClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'hide-sidebar');
                        $('#displayTextLeft').html('<span>'+ window.side_bar.hide_sidebar + '</span>');
                    } else {
                        $('.sidebar').fadeOut(800);
                        $('#displayTextLeft').removeClass('hidden-arrow-left');
                        $('#displayTextLeft').attr('title', 'show-sidebar');
                        $('#displayTextLeft').html('<span>' + window.side_bar.show_sidebar + '</span>');
                        //jQuery('.col-main').fadeIn(800);
                    }
                });
            //}
        },
        initSidebar: function() {
            //if category page then init sidebar
            if ($(".collection-sidebar").length > 0) {
                forte.sidebarParams();
                forte.initSortby();
                forte.sidebarMapEvents();
                forte.sidebarMapPaging();
                forte.sidebarInitToggle();
                forte.sidebarMapClear();
                forte.sidebarMapClearAll();
            }
        },
        initHeader: function () {
          if ($('.header-mobile').is(':hidden')) {
              var heightHeader = jQuery('.site-header').outerHeight();
              $('.main-content').css('padding-top',heightHeader);
          } else {
              $('.main-content').css('padding-top',0);
          }
        },
        initDropdownAccount: function() {
            if ($('.header-mobile').is(':visible')) {
                $('.currency').prependTo(jQuery('.header-top'));  
                $('.lang-block').prependTo(jQuery('.header-top'));
                
            } else {
                $('.currency').appendTo(jQuery('.header-panel')).after(jQuery('.nav-search'));
              	$('.lang-block').appendTo(jQuery('.header-panel')).after(jQuery('.nav-search'));
            }
        },
        initWishlist: function() {
            $('.grid-item button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        forte.showLoading();
                    },
                    success: function(data) {
                        forte.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><i class="fa fa-heart"></i><span>Go to wishlist</span></a>');
                        var title = item.find('.product-title').html();
                        var image = item.find('a > img').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        forte.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        forte.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        forte.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initProductWishlist: function() {
            $('.product button.wishlist').click(function(e) {
                e.preventDefault();
                var form = $(this).parent();
                var item = form.parents('.grid-item');
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        forte.showLoading();
                    },
                    success: function(data) {
                        forte.hideLoading();
                        form.html('<a class="wishlist" href="/pages/wish-list" title="Go to wishlist"><span class="icon"></span><span>Go to wishlist</span></a>');
                        var title = $('.product-title h2').html();
                        var image = $('#product-featured-image').attr('src');
                        $('.ajax-success-modal').find('.ajax-product-title').html(title);
                        $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                        $('.ajax-success-modal').find('.btn-go-to-wishlist').show();
                        $('.ajax-success-modal').find('.btn-go-to-cart').hide();
                        forte.showModal('.ajax-success-modal');
                    },
                    error: function(xhr, text) {
                        forte.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        forte.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initRemoveWishlist: function() {
            $('.btn-remove-wishlist').click(function(e) {
                var row = $(this).parents('li');
                var tagID = row.find('.tag-id').val();
                var form = jQuery('#remove-wishlist-form');
                form.find("input[name='contact[tags]']").val('x' + tagID);
                $.ajax({
                    type: 'POST',
                    url: '/contact',
                    data: form.serialize(),
                    beforeSend: function() {
                        forte.showLoading();
                    },
                    success: function(data) {
                        forte.hideLoading();
                        row.fadeOut(1000);
                    },
                    error: function(xhr, text) {
                        forte.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        forte.showModal('.ajax-error-modal');
                    }
                });
            });
        },
        initColorSwatchGrid: function() { 
          jQuery('.item-swatch li label').hover(function(){
            var newImage = jQuery(this).parent().find('.hidden a').attr('href');
            jQuery(this).parents('.grid-item').find('.product-grid-image img').attr({ src: newImage }); 
            return false;
          });
        },
        initResizeImage: function() {
            if (window.product_image_resize) {
                $('.products-grid .product-image img').fakecrop({
                    fill: window.images_size.is_crop,
                    widthSelector: ".products-grid .grid-item .product-image",
                    ratioWrapper: window.images_size
                });
            }
        },
        initInfiniteScrolling: function() {
            if ($('.infinite-scrolling').length > 0) {
                $('.infinite-scrolling a').click(function(e) {
                    e.preventDefault();
                    if (!$(this).hasClass('disabled')) {
                        forte.doInfiniteScrolling();
                    }
                });
            }
        },
        doInfiniteScrolling: function() {
            var currentList = $('.block-row .products-grid');
            if (!currentList.length) {
                currentList = $('.block-row .product-list');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        forte.showLoading();
                        $('.loading-modal').show();
                    },
                    success: function(data) {
                        forte.hideLoading();
                        var products = $(data).find(".block-row .products-grid");
                        if (!products.length) {
                            products = $(data).find(".block-row .product-list");
                        }
                        if (products.length) {
                            if (products.hasClass('products-grid')) {
                                /*fake crop*/
                                if (window.product_image_resize) {
                                    products.children().find('img').fakecrop({
                                        fill: window.images_size.is_crop,
                                        widthSelector: ".products-grid .grid-item .product-image",
                                        ratioWrapper: window.images_size
                                    });
                                }
                            }

                            currentList.append(products.children());
                            forte.translateBlock("." + currentList.attr("class"));
                            forte.initQuickView();
                            forte.initAddToCart();
                            forte.initWishlist();
                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                            } else {
                                //no more products
                                showMoreButton.hide();
                                showMoreButton.next().show();
                            }
                          
                          	//currency
                            if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
                          
                            forte.initColorSwatchGrid();
                          
                            //product review
                            if ($(".spr-badge").length > 0) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }
                        }
                    },
                    error: function(xhr, text) {
                        forte.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        forte.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        },
        closeEmailModalWindow: function() {
            if ($('#email-modal').length > 0 && $('#email-modal').is(':visible')) {
                $('#email-modal .modal-window').fadeOut(600, function() {
                    $('#email-modal .modal-overlay').fadeOut(600, function() {
                        $('#email-modal').hide();
                        $.cookie('emailSubcribeModal', 'closed', {
                            expires: 1,
                            path: '/'
                        });
                    });
                });
            }
        },
        showModal: function(selector) {
            $(selector).fadeIn(500)
            forte.forteTimeout = setTimeout(function() {
                $(selector).fadeOut(500);
            }, 5000);
        },
        initToggleCollectionPanel: function() {
            if ($('.collection-sharing-btn').length > 0) {
                $('.collection-sharing-btn').click(function() {
                    $('.collection-sharing-panel').toggle();
                    if ($('.collection-sharing-panel').is(':visible')) {
                        $('.collection-sharing-btn').addClass('btn-hover');
                        $('.collection-filter-panel').hide();
                        $('.collection-filter-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    }
                });
            }
            if ($('.collection-filter-btn').length > 0) {
                $('.collection-filter-btn').click(function() {
                    $('.collection-filter-panel').toggle();
                    if ($('.collection-filter-panel').is(':visible')) {
                        $('.collection-filter-btn').addClass('btn-hover');
                        $('.collection-sharing-panel').hide();
                        $('.collection-sharing-btn').removeClass('btn-hover');
                    } else {
                        $('.collection-filter-btn').removeClass('btn-hover');
                    }
                });
                $('.collection-filter-panel select').change(function(index) {
                    window.location = $(this).find('option:selected').val();
                });
            }
        },
        checkItemsInDropdownCart: function() {
            if ($('#dropdown-cart .mini-products-list').children().length > 0) {
                //Has item in dropdown cart
                $('#dropdown-cart .no-items').hide();
                $('#dropdown-cart .has-items').show();
            } else {
                //No item in dropdown cart                
                $('#dropdown-cart .has-items').hide();
                $('#dropdown-cart .no-items').show();
            }
        },
        initModal: function() {
            $('.continue-shopping').click(function() {
                clearTimeout(forte.forteTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
            $('.close-modal, .overlay').click(function() {
                clearTimeout(forte.forteTimeout);
                $('.ajax-success-modal').fadeOut(500);
            });
        },
        initDropDownCart: function() {
            if (window.dropdowncart_type == "click") {
                //click type  
                $('#cartToggle').click(function() {
                    if ($('#dropdown-cart').is(':visible')) {
                        $("#dropdown-cart").slideUp('fast');
                    } else {
                        $("#dropdown-cart").slideDown('fast');
                    }
                });
            } else {
                //hover type
                if (!('ontouchstart' in document)) {
                    $('#cartToggle').hover(function() {
                        if (!$('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                    $('.wrapper-top-cart').mouseleave(function() {
                        $("#dropdown-cart").slideUp('fast');
                    });
                } else {
                    //mobile
                    $('#cartToggle').click(function() {
                        if ($('#dropdown-cart').is(':visible')) {
                            $("#dropdown-cart").slideUp('fast');
                        } else {
                            $("#dropdown-cart").slideDown('fast');
                        }
                    });
                }
            }

            forte.checkItemsInDropdownCart();

            $('#dropdown-cart .no-items a').click(function() {
                $("#dropdown-cart").slideUp('fast');
            });

            $('#dropdown-cart .btn-remove').click(function(event) {
                event.preventDefault();
                var productId = $(this).parents('.item').attr('id');
                productId = productId.match(/\d+/g);
                Shopify.removeItem(productId, function(cart) {
                    forte.doUpdateDropdownCart(cart);
                });
            });
        },
        closeDropdownCart: function() {
            if ($('#dropdown-cart').is(':visible')) {
                $('#dropdown-cart').slideUp('fast');
            }
        },
        initProductMoreview: function() {
            if ($('.more-view-wrapper.horizontal').length > 0) {
                this.initOwlMoreview();
            } else if ($('.more-view-wrapper.vertical').length > 0) {
                this.initJcarouselMoreview();
            }
        },
        initOwlMoreview: function() {
            $('.more-view-wrapper.horizontal ul').owlCarousel({
                pagination: false,
                navigation: true,
                itemsDesktop: [1199, 4],
                itemsDesktopSmall: [979, 3],
                itemsTablet: [768, 3],
                itemsTabletSmall: [540, 3],
                itemsMobile: [360, 3]
            });
        },
        initJcarouselMoreview: function() {
            $('.more-view-wrapper.vertical ul').jcarousel({
                vertical: true
            });
        },
        initCloudzoom: function() { 
            if ($("#product-featured-image").length > 0) {
                if ($(".visible-phone").is(":visible")) {
                    //mobile display
                    $("#product-featured-image").elevateZoom({
                        gallery: 'more-view-carousel',
                        cursor: 'pointer',
                        galleryActiveClass: 'active',
                        imageCrossfade: false,
                        scrollZoom: false,
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide();
                        },
                        loadingIcon: window.loading_url
                    });
                    $("#product-featured-image").bind("click", function(e) {
                        return false;
                    });
                } else {
                    $("#product-featured-image").elevateZoom({
                        gallery: 'more-view-carousel',
                        cursor: 'pointer',
                        galleryActiveClass: 'active',
                        imageCrossfade: true,
                        scrollZoom: true,
                        onImageSwapComplete: function() {
                            $(".zoomWrapper div").hide();
                        },
                        loadingIcon: window.loading_url
                    });

                    $("#product-featured-image").bind("click", function(e) {
                        var ez = $('#product-featured-image').data('elevateZoom');
                        $.fancybox(ez.getGalleryList());
                        return false;
                    });
                }
            }
        },
        initScrollTop: function() {
            $('#back-top').click(function() {
                $('body,html').animate({
                    scrollTop: 0
                }, 400);
                return false;
            });
        },
        initProductAddToCart: function() {
            if ($('#product-add-to-cart').length > 0) {
                $('#product-add-to-cart').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        if (!window.ajax_cart) {
                            $(this).closest('form').submit();
                        } else {
                            var variant_id = $('#add-to-cart-form select[name=id]').val();
                            if (!variant_id) {
                                variant_id = $('#add-to-cart-form input[name=id]').val();
                            }
                            var quantity = $('#add-to-cart-form input[name=quantity]').val();
                            if (!quantity) {
                                quantity = 1;
                            }
                            var title = $('.product-title h2').html();
                            var image = $('#product-featured-image').attr('src');
                            forte.doAjaxAddToCart(variant_id, quantity, title, image);
                        }
                    }
                    return false;
                });
            }
        },
        initAddToCart: function() {
            if ($('.add-to-cart-btn').length > 0) {
                $('.add-to-cart-btn').click(function(event) {
                    event.preventDefault();
                    if ($(this).attr('disabled') != 'disabled') {
                        var productItem = $(this).parents('.product-item');
                        var productId = $(productItem).attr('id');
                        productId = productId.match(/\d+/g);
                        if (!window.ajax_cart) {
                            $('#product-actions-' + productId).submit();
                        } else {
                            var variant_id = $('#product-actions-' + productId + ' select[name=id]').val();
                            if (!variant_id) {
                                variant_id = $('#product-actions-' + productId + ' input[name=id]').val();
                            }
                            var quantity = $('#product-actions-' + productId + ' input[name=quantity]').val();
                            if (!quantity) {
                                quantity = 1;
                            }
                            var title = $(productItem).find('.product-title').html();
                            var image = $(productItem).find('.product-grid-image img').attr('src');
                            forte.doAjaxAddToCart(variant_id, quantity, title, image);
                        }
                    }
                    return false;
                });
            }
        },
        showLoading: function() {
            $('.loading-modal').show();
        },
        hideLoading: function() {
            $('.loading-modal').hide();
        },
        doAjaxAddToCart: function(variant_id, quantity, title, image) {
            $.ajax({
                type: "post",
                url: "/cart/add.js",
                data: 'quantity=' + quantity + '&id=' + variant_id,
                dataType: 'json',
                beforeSend: function() {
                    forte.showLoading();
                },
                success: function(msg) {
                    forte.hideLoading();
                    $('.ajax-success-modal').find('.ajax-product-title').html(forte.translateText(title));
                    $('.ajax-success-modal').find('.ajax-product-image').attr('src', image);
                    $('.ajax-success-modal').find('.btn-go-to-wishlist').hide();
                    $('.ajax-success-modal').find('.btn-go-to-cart').show();

                    forte.showModal('.ajax-success-modal');
                    forte.updateDropdownCart();
                },
                error: function(xhr, text) {
                    forte.hideLoading();
                    $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    forte.showModal('.ajax-error-modal');
                }
            });
        },
        initQuickView: function() {
            $('.quickview-button a').click(function() {
                var product_handle = $(this).attr('id');
                Shopify.getProduct(product_handle, function(product) {
                    var template = $('#quickview-template').html();
                    $('.quick-view').html(template);
                    var quickview = $('.quick-view');

                    quickview.find('.product-title a').html(forte.translateText(product.title));
                    quickview.find('.product-title a').attr('href', product.url);
                    if (quickview.find('.sample-vendor > span').length > 0) {
                        quickview.find('.sample-vendor > span').text(product.vendor);
                    }
                    if (quickview.find('.product-vendor > span').length > 0) {
                        quickview.find('.product-vendor > span').text(product.vendor);
                    }
                    if (quickview.find('.product-type > span').length > 0) {
                        quickview.find('.product-type > span').text(product.type);
                    }
                    if (quickview.find('.product-inventory > span').length > 0) {
                      var variant = product.variants[0];
                      var inventoryInfo = quickview.find('.product-inventory > span');                      
                      if (variant.available) {
                        if (variant.inventory_management!=null) {
                          inventoryInfo.text(variant.inventory_quantity + " " + window.inventory_text.in_stock);
                        } else {
                          inventoryInfo.text(window.inventory_text.many_in_stock);
                        }
                      } else {
                        inventoryInfo.text(window.inventory_text.out_of_stock);
                      }
                    }
                    //countdown for quickview
                    if (product.description.indexOf("[countdown]") > 0) {
                        var countdownTime = product.description.match(/\[countdown\](.*)\[\/countdown\]/);
                        if (countdownTime && countdownTime.length > 0) {
                            quickview.find(".countdown").show();
                            quickview.find(".quickview-clock").countdown(countdownTime[1], function(event) {
                                $(this).html(event.strftime('%Dd %H:%M:%S'));
                            });
                        }
                    }
                    if (quickview.find('.product-description').length > 0) {
                        var description = product.description.replace(/(<([^>]+)>)/ig, "");
                        var description = description.replace(/\[countdown\](.*)\[\/countdown\]/g, "");
                        
                        if (window.multi_lang) {
                          if (description.indexOf("[lang2]") > 0) {
                            var descList = description.split("[lang2]");
                            description = descList[translator.current_lang - 1];
                          }
                        }
                        description = description.split(" ").splice(0, 25).join(" ") + "...";
                        quickview.find('.product-description').text(description);
                    } else {
                        quickview.find('.product-description').remove();
                    }

                    quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
                    quickview.find('.product-item').attr('id', 'product-' + product.id);
                    quickview.find('.variants').attr('id', 'product-actions-' + product.id);
                    quickview.find('.variants select').attr('id', 'product-select-' + product.id);

                    //if has compare price
                    if (product.compare_at_price > product.price) {
                        quickview.find('.compare-price').html(Shopify.formatMoney(product.compare_at_price_max, window.money_format)).show();
                        quickview.find('.price').addClass('on-sale');
                    } else {
                        quickview.find('.compare-price').remove();
                        quickview.find('.price').removeClass('on-sale');
                    }

                    //out of stock
                    if (!product.available) {
                        quickview.find("select, input, .total-price, .dec, .inc, .variants label, .extra").remove();
                        quickview.find(".add-to-cart-btn").text(window.inventory_text.unavailable).addClass('disabled').attr("disabled", "disabled");;
                    } else {
                        quickview.find('.total-price span').html(Shopify.formatMoney(product.price, window.money_format));
                        if (window.use_color_swatch) {
                            forte.createQuickViewVariantsSwatch(product, quickview);
                        } else {
                            forte.createQuickViewVariants(product, quickview);
                        }
                    }

                    //quantity
                    quickview.find(".button").on("click", function() {
                        var oldValue = quickview.find(".quantity").val(),
                            newVal = 1;
                        if ($(this).text() == "+") {
                            newVal = parseInt(oldValue) + 1;
                        } else if (oldValue > 1) {
                            newVal = parseInt(oldValue) - 1;
                        }
                        quickview.find(".quantity").val(newVal);

                        if (quickview.find(".total-price").length > 0) {
                            forte.updatePricingQuickview();
                        }
                    });

                    if (window.show_multiple_currencies) {
                        Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), 'span.money', 'money_format');
                    }

                    forte.loadQuickViewSlider(product, quickview);
                    forte.initQuickviewAddToCart();
                    forte.translateBlock(".quick-view");                    

                    $('.quick-view').fadeIn(500);
                    if ($('.quick-view .total-price').length > 0) {
                        $('.quick-view input[name=quantity]').on('change', forte.updatePricingQuickview);
                    }
                });

                return false;
            });

            $(document).on("click", ".quick-view .overlay, .close-window", function() {
                forte.closeQuickViewPopup();
                return false;
            });
        },
        updatePricingQuickview: function() {
            //try pattern one before pattern 2
            var regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;
            var unitPriceTextMatch = $('.quick-view .price').text().match(regex);

            if (!unitPriceTextMatch) {
                regex = /([0-9]+[.|,][0-9]+)/g;
                unitPriceTextMatch = $('.quick-view .price').text().match(regex);
            }

            if (unitPriceTextMatch) {
                var unitPriceText = unitPriceTextMatch[0];
                var unitPrice = unitPriceText.replace(/[.|,]/g, '');
                var quantity = parseInt($('.quick-view input[name=quantity]').val());
                var totalPrice = unitPrice * quantity;

                var totalPriceText = Shopify.formatMoney(totalPrice, window.money_format);
                regex = /([0-9]+[.|,][0-9]+[.|,][0-9]+)/g;     
                if (!totalPriceText.match(regex)) {
                   regex = /([0-9]+[.|,][0-9]+)/g;
                } 
                totalPriceText = totalPriceText.match(regex)[0];

                var regInput = new RegExp(unitPriceText, "g");
                var totalPriceHtml = $('.quick-view .price').html().replace(regInput, totalPriceText);

                $('.quick-view .total-price span').html(totalPriceHtml);
            }
        },
        initQuickviewAddToCart: function() {
            if ($('.quick-view .add-to-cart-btn').length > 0) {
                $('.quick-view .add-to-cart-btn').click(function() {
                    var variant_id = $('.quick-view select[name=id]').val();
                    if (!variant_id) {
                        variant_id = $('.quick-view input[name=id]').val();
                    }
                    var quantity = $('.quick-view input[name=quantity]').val();
                    if (!quantity) {
                        quantity = 1;
                    }

                    var title = $('.quick-view .product-title a').html();
                    var image = $('.quick-view .quickview-featured-image img').attr('src');
                    forte.doAjaxAddToCart(variant_id, quantity, title, image);
                    forte.closeQuickViewPopup();
                });
            }
        },
        updateDropdownCart: function() {
            Shopify.getCart(function(cart) {
                forte.doUpdateDropdownCart(cart);
            });
        },
        doUpdateDropdownCart: function(cart) {
            var template = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove">X</a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';

            $('#cartCount').text(cart.item_count);
            /*Total price*/
            $('#dropdown-cart .summary .price').html(Shopify.formatMoney(cart.total_price, window.money_format));
            /*Clear cart*/
            $('#dropdown-cart .mini-products-list').html('');
            /*Add product to cart*/
            if (cart.item_count > 0) {
                for (var i = 0; i < cart.items.length; i++) {
                    var item = template;
                    item = item.replace(/\{ID\}/g, cart.items[i].id);
                    item = item.replace(/\{URL\}/g, cart.items[i].url);
                    item = item.replace(/\{TITLE\}/g, forte.translateText(cart.items[i].title));
                    item = item.replace(/\{QUANTITY\}/g, cart.items[i].quantity);
                    item = item.replace(/\{IMAGE\}/g, Shopify.resizeImage(cart.items[i].image, 'small'));
                    item = item.replace(/\{PRICE\}/g, Shopify.formatMoney(cart.items[i].price, window.money_format));
                    $('#dropdown-cart .mini-products-list').append(item);
                }
                $('#dropdown-cart .btn-remove').click(function(event) {
                    event.preventDefault();
                    var productId = $(this).parents('.item').attr('id');
                    productId = productId.match(/\d+/g);
                    Shopify.removeItem(productId, function(cart) {
                        forte.doUpdateDropdownCart(cart);
                    });
                });
                if (forte.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#dropdown-cart span.money', 'money_format');
                }
            }
            forte.checkItemsInDropdownCart();
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency;
        },
        loadQuickViewSlider: function(product, quickviewTemplate) {
            var featuredImage = Shopify.resizeImage(product.featured_image, 'grande');
            quickviewTemplate.find('.quickview-featured-image').append('<a href="' + product.url + '"><img src="' + featuredImage + '" title="' + product.title + '"/><div style="height: 100%; width: 100%; top:0; left:0 z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            
            if (product.images.length > 1) {
                var quickViewCarousel = quickviewTemplate.find('.more-view-wrapper ul');
                var count = 0;
                for (i in product.images) {
                  if (count < product.images.length) {
                    var grande = Shopify.resizeImage(product.images[i], 'grande');
                    var compact = Shopify.resizeImage(product.images[i], 'compact');
                    var item = '<li><a href="javascript:void(0)" data-image="' + grande + '"><img src="' + compact + '"  /></a></li>'

                    quickViewCarousel.append(item);
                    count = count + 1;
                  }
                }
              
                quickViewCarousel.find('a').click(function() {
                    var quickViewFeatureImage = quickviewTemplate.find('.quickview-featured-image img');
                    var quickViewFeatureLoading = quickviewTemplate.find('.quickview-featured-image div');
                    if (quickViewFeatureImage.attr('src') != $(this).attr('data-image')) {
                        quickViewFeatureImage.attr('src', $(this).attr('data-image'));
                        quickViewFeatureLoading.show();
                        quickViewFeatureImage.load(function(e) {
                            quickViewFeatureLoading.hide();
                            $(this).unbind('load');
                            quickViewFeatureLoading.hide();
                        });
                    }
                });
                if (quickViewCarousel.parent().hasClass("horizontal")) {
                    forte.initQuickViewCarousel(quickViewCarousel);
                } else {
                    forte.initQuickViewVerticalMoreview(quickViewCarousel);
                }
            } else {
                quickviewTemplate.find('.product-img-box').removeClass('has-jcarousel');
                quickviewTemplate.find('.quickview-more-views').remove();
                quickviewTemplate.find('.quickview-more-views.vertical').remove();
            }

        },
        initQuickViewCarousel: function(quickViewCarousel) {
            if (quickViewCarousel) {
                quickViewCarousel.owlCarousel({
                    pagination: false,
                    navigation: true,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [540, 3],
                    itemsMobile: [360, 3]
                });
            }
        },
        initQuickViewVerticalMoreview: function(quickViewCarousel) {
            if (quickViewCarousel) {
                quickViewCarousel.jcarousel({
                    vertical: true
                });
                $('.quick-view .product-img-box').addClass('has-jcarousel');
            }
        },
        convertToSlug: function(text) {
            return text
                .toLowerCase()
                .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-');
        },
        createQuickViewVariantsSwatch: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }
                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });

                //start of quickview variant;
                var filePath = window.file_url.substring(0, window.file_url.lastIndexOf('?'));
                var assetUrl = window.asset_url.substring(0, window.asset_url.lastIndexOf('?'));
                var options = "";
                for (var i = 0; i < product.options.length; i++) {
                    options += '<div class="swatch clearfix" data-option-index="' + i + '">';
                    options += '<div class="header">' + product.options[i].name + '</div>';
                    var is_color = false;
                    if (/Color|Colour/i.test(product.options[i].name)) {
                        is_color = true;
                    }
                    var optionValues = new Array();
                    for (var j = 0; j < product.variants.length; j++) {
                        var variant = product.variants[j];
                        var value = variant.options[i];
                        var valueHandle = this.convertToSlug(value);
                        var forText = 'swatch-' + i + '-' + valueHandle;
                        if (optionValues.indexOf(value) < 0) {
                            //not yet inserted
                            options += '<div data-value="' + value + '" class="swatch-element ' + (is_color ? "color" : "") + valueHandle + (variant.available ? ' available ' : ' soldout ') + '">';

                            if (is_color) {
                                options += '<div class="tooltip">' + value + '</div>';
                            }
                            options += '<input id="' + forText + '" type="radio" name="option-' + i + '" value="' + value + '" ' + (j == 0 ? ' checked ' : '') + (variant.available ? '' : ' disabled') + ' />';

                            if (is_color) {
                                options += '<label for="' + forText + '" style="background-color: ' + valueHandle + '; background-image: url(' + filePath + valueHandle + '.png)"><img class="crossed-out" src="' + assetUrl + '" /></label>';
                            } else {
                                options += '<label for="' + forText + '">' + value + '<img class="crossed-out" src="' + assetUrl + '" /></label>';
                            }
                            options += '</div>';
                            if (variant.available) {
                                $('.quick-view .swatch[data-option-index="' + i + '"] .' + valueHandle).removeClass('soldout').addClass('available').find(':radio').removeAttr('disabled');
                            }
                            optionValues.push(value);
                        }
                    }
                    options += '</div>';
                }
                quickviewTemplate.find('form.variants > select').after(options);
                quickviewTemplate.find('.swatch :radio').change(function() {
                    var optionIndex = $(this).closest('.swatch').attr('data-option-index');
                    var optionValue = $(this).val();
                    $(this)
                        .closest('form')
                        .find('.single-option-selector')
                        .eq(optionIndex)
                        .val(optionValue)
                        .trigger('change');
                });
                if (product.available) {
                    Shopify.optionsMap = {};
                    Shopify.linkOptionSelectors(product);
                }

                //end of quickview variant
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }
        },
        createQuickViewVariants: function(product, quickviewTemplate) {
            if (product.variants.length > 1) { //multiple variants
                for (var i = 0; i < product.variants.length; i++) {
                    var variant = product.variants[i];
                    var option = '<option value="' + variant.id + '">' + variant.title + '</option>';
                    quickviewTemplate.find('form.variants > select').append(option);
                }

                new Shopify.OptionSelectors("product-select-" + product.id, {
                    product: product,
                    onVariantSelected: selectCallbackQuickview
                });
                $('.quick-view .single-option-selector').selectize();
                $('.quick-view .selectize-input input').attr("disabled", "disabled");

                if (product.options.length == 1) {
                    $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
                }
                quickviewTemplate.find('form.variants .selector-wrapper label').each(function(i, v) {
                    $(this).html(product.options[i].name);
                });
            } else { //single variant
                quickviewTemplate.find('form.variants > select').remove();
                var variant_field = '<input type="hidden" name="id" value="' + product.variants[0].id + '">';
                quickviewTemplate.find('form.variants').append(variant_field);
            }

        },
        closeQuickViewPopup: function() {
            $('.quick-view').fadeOut(500);
        },
//       js infinity scroll
        initInfiniteScrollingss: function() {
            if ($('.collection-all .infinite-scrolling').length > 0) {
                $('.collection-all .infinite-scrolling a').click(function(e) {
                    e.preventDefault();
                    if (!$(this).hasClass('disabled')) {
                        forte.doInfiniteScrollingss();
                    }
                });
            }
          window.infinitPos = 0;
               $(window).scroll(function(event) {
            if ($(".infinite-scrolling").length>0) {
              var pos = $(".infinite-scrolling").offset().top;
              if ($(this).scrollTop() > (pos - 600) && $(".infinite-scrolling").length>0
                  && $(".infinite-scrolling a:eq(0)").is(":visible")
                  && $(this).scrollTop() - window.infinitPos > 1000
                 ) {
                window.infinitPos = $(this).scrollTop();
                $(".infinite-scrolling a").trigger("click");
                event.stopPropagation();
                event.preventDefault();
              }
            }
          });
        },
        doInfiniteScrollingss: function() {
            var currentList = $('.collection-list');
            if (!currentList.length) {
                currentList = $('.block-row .product-list');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        forte.showLoading();
                        $('.loading-modal').show();
                        showMoreButton.hide();
                    },
                    success: function(data) {
                        
                        showMoreButton.show();
                        var products = $(data).find(".collection-list");
                        if (!products.length) {
                            products = $(data).find(".block-row .product-list");
                        }
                        if (products.length) {

                            currentList.append(products.children());
                            forte.translateBlock("." + currentList.attr("class"));

                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));

                            } else {
                                //no more products
                              	forte.hideLoading();
                                showMoreButton.hide();
                                showMoreButton.next().show();
                              	forte.checkletter();
                              	
                            }
                          
                        }
                    },
                    error: function(xhr, text) {
                        forte.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        forte.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        },
      checkletter: function(){
        $('.collection-list li').each(function(){
        	var cap = $(this).data('check');
            $('top__brands__list .collection-letter').hide().filter(function(evt){
              var id = evt.id
              return $(this).attr('data-id').toLowerCase()[0] == cap;
            }).show()
          	
        });
      },
//       infinity scroll all-collections
      
        translateText: function(str) {
          if (!window.multi_lang || str.indexOf("|") < 0)
            return str;

          if (window.multi_lang) {
            var textArr = str.split("|");
            if (translator.isLang2())
              return textArr[1];
            return textArr[0];
          }          
        },
      translateBlock: function(blockSelector) {
          if (window.multi_lang && translator.isLang2()) {
          translator.doTranslate(blockSelector);
        }
      }
    }
    jQuery(window).scroll(function() {    
    var scroll = jQuery(window).scrollTop();

    if (scroll >= 150) {
        jQuery(".site-header").addClass("hide_banner");
    } else {
        jQuery(".site-header").removeClass("hide_banner");
    }
	});
  jQuery('.icon_search').click(function() {
		jQuery('.hide_banner .search_mn .search-bar').slideUp();
		if (!jQuery(this).next().is(":visible")) {
			jQuery(this).next().slideDown();
		}
	});
})(jQuery);

$(function() {
  $('input[name="checkout"], button[name="checkout"], input[name="goto_pp"], input[name="goto_gc"]').click(function() {
    var formIsValid = true;
    var message = "Please select a delivery date and time.";

    $('[name^="attributes"]').filter('.required, [required ="required"]').each(function() {
      $(this).removeClass('error');
      if (formIsValid && ($(this).val() == "" || $(this).val() == null)) {
        formIsValid = false;
        message = $(this).attr('data-error') || message;
        $(this).addClass('error');
      }
    });
    if (formIsValid){
      $(this).submit();
    }
    else {
      alert(message);
      return false;
    }
  });
});